'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { ThemeProvider } from 'hooks/useTheme';

import MakersReserveHero from '../MakersReserve/MakersReserveHero';

import styles from './Default.module.scss';

const Default = ({ blocks, theme }) => {
    blocks ??= [];
    theme ??= 'default';

    function isInView(element) {
        const { top, left, bottom, right } = element.getBoundingClientRect();

        return (
            top >= 0 &&
            left >= 0 &&
            bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const handleLoad = () => {
        if (window.location.hash) {
            const id = window.location.hash.replace(/#/g, '');
            const element = document.getElementById(id);

            if (element && !isInView(element)) {
                element.scrollIntoView();
            }
        }
    };

    useEffect(() => {
        window.addEventListener('load', handleLoad);

        return () => {
            window.removeEventListener('load', handleLoad);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className={cx({
                [styles.makersReserve]: theme === 'makers-reserve',
            })}
        >
            {theme === 'makers-reserve' && <MakersReserveHero />}
            <ThemeProvider theme={theme}>{blocks}</ThemeProvider>
        </div>
    );
};

Default.propTypes = {
    blocks: PropTypes.array,
    theme: PropTypes.oneOf(['default', 'makers-reserve']),
};

export default Default;
